import { MessageSquare, Send } from "lucide-react";
import { useState } from "react";
import { addResumeComment } from "../api/comments"
import { LastFetchedAt } from "./timers/LastFetchedAt";
import { useResumesContext } from "../context/resumes-context";
import { ClipLoader } from "react-spinners";

// const mockcomments = [
//     { id: 1, author_name: "Ravi Kumar", created_at: "2025-08-15 10:32", content: "Good structure, but try adding more measurable achievements." },
//     { id: 2, author_name: "Neha Sharma", created_at: "2025-08-15 11:05", content: "Skills section is strong, but the summary feels too generic." },
//     { id: 3, author_name: "Amit Singh", created_at: "2025-08-15 11:47", content: "Consider shortening the work experience descriptions for readability." },
//     { id: 4, author_name: "Priya Verma", created_at: "2025-08-15 12:20", content: "Education details are clear, but missing any relevant certifications." },
//     { id: 5, author_name: "Vikram Joshi", created_at: "2025-08-15 12:58", content: "Layout is clean, but try using more action verbs in bullet points." }
//   ];

export const CommentSection = ({ resumeId, token='' }) => {

    const { fetchResumeDetail, resumeDetails  } = useResumesContext()

    const addCommentHandler = async function (params) {
        console.log("called addCommentHandler ")
        setError('')
        setloading(true)
        const { success, resp } = await addResumeComment(resumeId, newComment, token)
        if(success){
            setNewComment('')
            await fetchResumeDetail(resumeId, true)
        }
        else{
            setError(resp)
        }
        setloading(false)
    }
    
    console.log({ commentsfrom: resumeDetails[resumeId]})
    const comments = resumeDetails[resumeId] || []
    // const comments = resume?.comments || mockcomments
    const [newComment, setNewComment] = useState('');
    const [loading, setloading] = useState(false);
    const [error, setError] = useState('');

    return (
        <div className="bg-white/50 p-6 rounded-xl max-sm:px-1 md:p-8  shadow-lg border border-blue-100">
            {error && <p className="text-red-500 font-semibold mb-8">{"*" + error}</p>}
            <div className="z-10 px-6 mx-2 sm:max-20 max-sm:px-2 py-10  bg-white/10 backdrop-blur-sm rounded-xl border border-slate-400/30 shadow-lg">
                <h3 className="text-lg font-bold text-gray-800 mb-3 flex items-center"><MessageSquare size={20} className="mr-2"/>Feedback & Comments</h3>
                <div className="space-y-4">
                    {comments.map(c => (
                        <div key={c.id} className="bg-gray-100 p-3 rounded-lg">
                            <div className="flex justify-between items-center mb-1">
                                <p className="font-semibold text-sm text-gray-800">{c.author_name}</p>
                                <p className="text-xs text-gray-500">
                                    <LastFetchedAt timestamp={c.created_at} action="" />
                                </p>
                            </div>
                            <p className="text-sm text-gray-700">{c.content}</p>
                        </div>
                    ))}
                </div>
                <div className="mt-4 flex">
                    {
                    !loading ? 
                        <>
                            <input  type="text" placeholder="Add your feedback..." 
                                    value={newComment} 
                                    onChange={e => setNewComment(e.target.value)} 
                                    className="flex-grow p-2 border rounded-l-lg text-sm"
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            e.preventDefault()
                                            addCommentHandler();
                                        }
                                      }} />
                            <button onClick={addCommentHandler} 
                                    className="bg-indigo-600 text-white p-2 rounded-r-lg hover:bg-indigo-700"><Send size={20}/></button>
                        </>
                    :
                        (
                            <div className="flex justify-center items-center w-full py-2">
                            <ClipLoader size={20} color="#4f46e5" />
                            </div>
                      )
                }
                </div>
            </div>
        </div>
    );
};